/** Overdue panel section for TodayViewPanels. */
import { TaskUIProvider } from '@/features/tasks';
import Panel from '@/components/ui/Panel';
import TodaySectionList from './TodaySectionList';
import {
  TODAY_PANEL_A11Y,
  TODAY_PANEL_FLAT_CLASS,
} from './todayViewPanelsHelpers';

export function TodayOverduePanelSection({
  t,
  isBattlefield,
  uiContextValue,
  displayOverdueTasks,
  topActionableTaskId,
  tasksMap,
  selectedTaskIds,
  setSelectedTaskIds,
}) {
  if (displayOverdueTasks.length === 0) {
    return null;
  }

  return (
    <TaskUIProvider value={{ ...uiContextValue, menuSurface: 'today-overdue' }}>
      <Panel
        flat
        contentClassName={TODAY_PANEL_FLAT_CLASS}
        title={t('todayviewcontent.overdue', 'Herplannen')}
        count={displayOverdueTasks.length}
        testId="panel-overdue"
        {...TODAY_PANEL_A11Y}
      >
        <TodaySectionList
          isBattlefield={isBattlefield}
          variant="simple"
          tasks={displayOverdueTasks}
          listId="overdue-list"
          dragEnabled
          dragType="overdue-task"
          menuSurface="today-overdue"
          topActionableTaskId={topActionableTaskId}
          showPlayButtonAlways
          tasksMap={tasksMap}
          selectedTaskIds={selectedTaskIds}
          onSelectionChange={setSelectedTaskIds}
        />
      </Panel>
    </TaskUIProvider>
  );
}
